var _rect, _rect2, _rect3, _g, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealLayoutD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 22,
    height: 17,
    rx: 1.5,
    stroke: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 15.5,
    width: 18,
    height: 1,
    rx: 0.5,
    stroke: "current"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11577_9862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 18,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11577_9862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.657012 14.6362C0.456084 14.8256 0.446761 15.1421 0.636188 15.343C0.825615 15.5439 1.14206 15.5532 1.34299 15.3638L0.657012 14.6362ZM7.75 8.63636L8.07199 8.25384L7.73117 7.96695L7.40701 8.27255L7.75 8.63636ZM13.15 13.1818L12.828 13.5643L13.1965 13.8746L13.5203 13.5178L13.15 13.1818ZM20.575 5L20.9249 4.6428L20.5538 4.27934L20.2047 4.66399L20.575 5ZM1.34299 15.3638L8.09299 9.00018L7.40701 8.27255L0.657012 14.6362L1.34299 15.3638ZM7.42801 9.01889L12.828 13.5643L13.472 12.7993L8.07199 8.25384L7.42801 9.01889ZM13.5203 13.5178L20.9453 5.33601L20.2047 4.66399L12.7797 12.8458L13.5203 13.5178ZM20.2251 5.3572L27.6501 12.6299L28.3499 11.9155L20.9249 4.6428L20.2251 5.3572Z",
    fill: "current"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 6,
    r: 1,
    stroke: "current",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealLayoutD1);
export default __webpack_public_path__ + "static/media/DealLayoutD_1.ef201ca27fb0f92554f88cb20c5ff443.svg";
export { ForwardRef as ReactComponent };